<div class="or-inline-items or-inline-tags or-editable">
  @if(isEditable) {
    <div class="or-inline-item or-inline-tag-add w-[120px] pt-1 pl-2">
      <mat-select placeholder="Pick a tag" #selectTag (selectionChange)="addActiveTag(selectTag.value)" data-cy="pick-a-tag-list" [disabled]="isSelectionDisabled">
        @for(tag of availableOptions; track $index){
          <mat-option [value]="tag.value | json">
            <app-tag-icon [tag]='tag.value' [inverse]='false'/>&nbsp;{{tag.label}}
          </mat-option>
        }
        @if(availableOptions.length === 0) {
          <mat-option disabled="true">No tags available</mat-option>
        }
      </mat-select>
    </div>
  }
  @for (tag of currentSelection; track tag.id) {
    <div class="or-inline-item or-inline-tag">
      <span class="or-inline-tag-color" [style]="{ backgroundColor: '#' + tag.color }"></span>
      <app-tag-icon [tag]='tag' [inverse]='false'/>&nbsp;
      <span class="or-inline-tag-name" [textContent]="tag.name" [style]="{ color: '#' + tag.color }" [attr.data-cy]="'selected-schedule-tag-'+tag.id"></span>
      @if (canEdit(tag)) {
        <button class="or-button or-inline-tag-remove" type='button' (click)="removeTag(tag.id)" [attr.data-cy]="'delete-schedule-tag-'+tag.id">
          <span class="or-icon or-tiny or-icon-cross"></span>
        </button>
      }
    </div>
  }
</div>
